import React from 'react'
import { Label } from 'semantic-ui-react'

class Badge extends React.PureComponent {
  render() {
    const { count } = this.props

    return count > 0 ? (
      <Label color="red" className="badge" content={count} />
    ) : (
      false
    )
  }
}

export default Badge



// WEBPACK FOOTER //
// ./src/components/admin/Helper/Badge.jsx